import MainPage from './components/MainPage';

// האתר ציבורי, אין מסך התחברות (בשונה מ-BackOfficeApp בקלאמקע).
// כשיתווספו מסכים עם כתובת משלהם — BrowserRouter כאן.
const ZolBakfarApp = () => {
  return (
    <div dir="rtl" lang="he">
      <MainPage />
    </div>
  );
};

export default ZolBakfarApp;
